import { createSelector, createFeatureSelector } from '@ngrx/store';

import { IState } from '@models/index';

export const downlineSelector = createFeatureSelector<IState>('downline');
export const getDownlinesSelector = createSelector(downlineSelector, (state: IState) => state); 
export const getDownlineSelector = createSelector(downlineSelector, (state: IState) => state.selectedItem); 
